//#region src/matching_type.ts
var MatchingType = /* @__PURE__ */ function(MatchingType) {
	MatchingType["Intersection"] = "intersection";
	MatchingType["Union"] = "union";
	return MatchingType;
}(MatchingType || {});
//#endregion
export { MatchingType };

//# sourceMappingURL=matching_type.js.map